import Cookies from 'universal-cookie';

export default (lang) => {
  const cookies = new Cookies();
  cookies.set('lang', lang, {
    domain: process.env.GATSBY_LANG_COOKIE_DOMAIN,
    path: '/',
  });
};
